module.exports = __webpack_public_path__ + "img/illustrator-timekeeping.947e576b.png";